// client/src/config/env.js
/**
 * Configuración centralizada de variables de entorno para el frontend.
 * Prioriza process.env.REACT_APP_API_URL y provee fallback automático
 * para producción (https://restaurantes.polidevs.com) y desarrollo local (http://localhost:4000).
 */
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.port === "3000" ||
    window.location.port === "5173");

export const API_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalhost
    ? "http://localhost:4000"
    : "https://restaurantes.polidevs.com");

export const DEFAULT_RESTAURANTE_ID =
  process.env.REACT_APP_RESTAURANTE_ID || 1;

const config = {
  API_URL,
  DEFAULT_RESTAURANTE_ID,
};

export default config;
